import { useEffect, useState } from 'react';
import { navigate, resolveLogoUrl } from './api';

interface OneliveLogoProps {
  src?: string;
  alt?: string;
  className?: string;
}

const DEFAULT_LOGO = '/assets/templates/onelive-basic/ftv/logo.svg';

export default function OneliveLogo({
  src,
  alt = 'NeoLive',
  className = 'onelive-logo-img',
}: OneliveLogoProps) {
  const [logoSrc, setLogoSrc] = useState(() => resolveLogoUrl(src || DEFAULT_LOGO) || DEFAULT_LOGO);
  const [useText, setUseText] = useState(false);

  useEffect(() => {
    setLogoSrc(resolveLogoUrl(src || DEFAULT_LOGO) || DEFAULT_LOGO);
    setUseText(false);
  }, [src]);

  if (useText) {
    return (
      <span className="onelive-logo-text" aria-label={alt}>
        <span className="onelive-logo-text-one">Neo</span>
        <span className="onelive-logo-text-live">Live</span>
        <span className="onelive-logo-text-dot" aria-hidden="true" />
      </span>
    );
  }

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={className}
      onError={() => {
        if (logoSrc !== DEFAULT_LOGO) {
          setLogoSrc(DEFAULT_LOGO);
          return;
        }
        setUseText(true);
      }}
    />
  );
}

export function OneliveLogoLink({
  src,
  alt,
  className,
}: OneliveLogoProps) {
  return (
    <a
      href="/"
      className="onelive-logo-link"
      onClick={(e) => {
        e.preventDefault();
        navigate('/');
      }}
    >
      <OneliveLogo src={src} alt={alt} className={className} />
    </a>
  );
}
